var map = {
	"./antenatalpatients.js": "8718",
	"./appointments.js": "17c9",
	"./audits.js": "ed58",
	"./birthcertificates.js": "ae66",
	"./consultationpatients.js": "ff47",
	"./countries.js": "54e1",
	"./deathcertificates.js": "34c1",
	"./dentalpatients.js": "1b34",
	"./discharges.js": "7d43",
	"./diseases.js": "fa6d",
	"./dispensemedicines.js": "077e",
	"./expensecarts.js": "975f",
	"./expensecategories.js": "343f",
	"./expenseitems.js": "368a",
	"./expenses.js": "f18a",
	"./groupaccountinvoices.js": "5c1f",
	"./groupaccountmembers.js": "5aaf",
	"./groupaccounts.js": "4046",
	"./inpatients.js": "1742",
	"./labpatients.js": "40460",
	"./labpatientsamples.js": "fed2",
	"./labsamples.js": "9bd1",
	"./labservices.js": "21ea",
	"./layout.js": "c21a",
	"./maternitypatients.js": "165e",
	"./notifications.js": "b67d",
	"./otherpatients.js": "8001",
	"./patientbalances.js": "16fc",
	"./patientdebtors.js": "b9c4",
	"./patientpayments.js": "45b6",
	"./patientreferrals.js": "f8e2",
	"./patients.js": "0284",
	"./patienttestresults.js": "174e",
	"./paymentoptions.js": "6e10",
	"./permissions.js": "f604",
	"./procedurepatients.js": "ac74",
	"./productcategories.js": "d3bc",
	"./productitemunits.js": "ae8e",
	"./products.js": "22ca",
	"./productunits.js": "4aa6",
	"./profiles.js": "62e6",
	"./purchasecarts.js": "f1ab",
	"./radiologypatients.js": "f273",
	"./reportappointments.js": "7e04",
	"./reportcashflows.js": "bc35",
	"./reportcashpayments.js": "63ec",
	"./reportdepartmentanalysis.js": "bbcd",
	"./reportdiagnosisanalysis.js": "9222",
	"./reportexpenses.js": "31b8",
	"./reportlabs.js": "714c",
	"./reportpaymentsbymonths.js": "929f",
	"./reportpaymentsbyoptions.js": "4b79",
	"./reportpaymentsbyuser.js": "6709",
	"./reportpersonalpayments.js": "fd0e",
	"./reportpharmacybymonths.js": "247f",
	"./reportpharmacypayments.js": "e947",
	"./reportpharmacypurchases.js": "b6f6",
	"./reportproductsdemands.js": "b9e2",
	"./reportpurchasesbysupplier.js": "6235",
	"./reportserviceanalysis.js": "beea",
	"./reportworkloadbyuser.js": "d7a2",
	"./roles.js": "b7c7",
	"./salecarts.js": "0ea3",
	"./savings.js": "9e5e",
	"./sellproductdetails.js": "0f89",
	"./servicecategories.js": "3241",
	"./services.js": "92e6",
	"./smsbundles.js": "80fb",
	"./smspurchases.js": "eb7a",
	"./stocklevels.js": "2c09",
	"./suppliers.js": "2006",
	"./testresults.js": "237e",
	"./theaterpatients.js": "f6da",
	"./users.js": "b20d",
	"./visits.js": "eff1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";